/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
'use client';
import React from 'react';
import styles from './Chip.module.css';
export default function Chip({
    children,
    active = false,
    size = 'md',
    onClick,
    className = '',
    ...props
}) {
    const classes = [
        styles.chip,
        active ? styles.active : '',
        styles[size],
        className
    ].filter(Boolean).join(' ');
    return (
        <button className={classes} onClick={onClick} {...props}>
            {children}
        </button>
    );
}
